export const LOADING_PLACEHOLDER_WIDTH = "100%";
export const LOADING_PLACEHOLDER_HEADER_HEIGHT = 9;
export const LOADING_PLACEHOLDER_CHANGE_HEIGHT = 32;
